import { useLocalStore, useAsObservableSource } from 'mobx-react-lite';

import { IcCalendarIcon, IcPublishIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import { Features } from 'APP/packages/features/Features';

export default ({ parent }) => {
  const { t } = useTranslation();
  const source = useAsObservableSource({ parent });

  const presenter = useLocalStore(() => ({
    get menuItems() {
      const items = [
        {
          key: 'send',
          icon: IcPublishIcon,
          title: t('common_publish_now'),
          onClick: source.parent.onSend,
          isVisible: true,
        },
        {
          key: 'scheduled',
          icon: IcCalendarIcon,
          title: t('common_publish_on_date'),
          onClick: source.parent.onScheduled,
          isVisible: Features.isScheduledMessagesEnabled(),
        },
      ];

      return items.filter((item) => item.isVisible);
    },
  }));

  return presenter;
};
